__turbopack_context__.v({
  "animationCube": "AnimationCube-module__6_cZXG__animationCube",
  "cube": "AnimationCube-module__6_cZXG__cube",
});
